/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import utils from "../../utils/utils";
import "./style.less";

class PipelineBtnRadioText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAgree: false
    };
  }

  componentDidMount() {}

  handleLinkClick = (link) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link,
        props: this.props
      })
      return
    }
    if (!link) {
      // 空白不跳转
      return;
    }
    const options = {
      link,
    };

    const convertUrl = utils.convertHref(link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,link, options, -1,this.props,false);
  };
  handleImgClick = (link) => {
    const { isAgree } = this.state;
    if (!link) {
      // 空白不跳转
      return;
    }
    const { showBtn } = this.props.config
    if(showBtn && !isAgree){
      window.Jockey.send('toast', {
        text: '请阅读并勾选相关协议'
      });
      return 
    }
    this.handleLinkClick(link)
  };
  render() {
    const { showBtn, text, textLink, src ,link } = this.props.config;
    const { isAgree } = this.state
    return (
      <div
        className="pipeline-btnRadioText"
        {...this.props['customAttributes']}
      >
        {showBtn && <div className="btn-container">
          <img className="img" src={isAgree ? "https://static.shihuocdn.cn/admin/files/20240529/6ea6334bc0a1a430a582447d18830a5a.png" : "https://static.shihuocdn.cn/admin/files/20240529/fc1ee7503b0946297a33fc5b1e4728f3.png" }
          onClick={()=>{
            this.setState({isAgree: !isAgree})
          }}/>
          <span className="txt">您已阅读并同意</span>
          {text && <span className="txtLink" onClick={this.handleLinkClick.bind(this,textLink)}>{text}</span>}
        </div>}
        <div className="img-item" onClick={this.handleImgClick.bind(this, link)}>
          <img className="img" src={utils.formatImgUrl(src, this.props.webpSupport)}/>
        </div>
      </div>
    );
  }
}

export { PipelineBtnRadioText };
export default PipelineBtnRadioText;



// WEBPACK FOOTER //
// ./components/pipeline-btnRadioText/index.js